import React, { Component } from 'react';
import CloseButton from './CloseButton';

require('./Modal.scss');
require('./SubmitModal.scss');

class SubmitModal extends Component {
    render () {
	return (
	    <div className="modalPanel submitModal">
		<div className="modalWrap">
		    <div className="modalHeader text-center">
			<img src={require('./assets/confirmIcon.png')} alt="Success!"/>
		    </div>
		    <div className="modalContent">
			<div className="container-fluid">
			    <div className="row">
				<div className="col-sm-6 col-sm-offset-3 text-center">
				    <h2>
                                        Time Entry
                                        {(this.props.submitted) ? 'Submitted' : 'Saved'}
                                    </h2>
				</div>
			    </div>
			</div>
		    </div>
		</div>
	    </div>
	);
    }
}

export default SubmitModal;



// WEBPACK FOOTER //
// ./app/components/Modals/SubmitModal.jsx